/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Under_10mbInputs */

const en_image_under_10mb = /** @type {(inputs: Image_Under_10mbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image must be under 10MB`)
};

const es_image_under_10mb = /** @type {(inputs: Image_Under_10mbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La imagen debe ser menor de 10MB`)
};

/**
* | output |
* | --- |
* | "Image must be under 10MB" |
*
* @param {Image_Under_10mbInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const image_under_10mb = /** @type {((inputs?: Image_Under_10mbInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Under_10mbInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_image_under_10mb(inputs)
	return es_image_under_10mb(inputs)
});